import { rankingCategorias } from '@acme/auth/roles'
import Dialog from 'global/guides/Dialog'
import { useAuth } from 'hooks'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import { EditarUsuarioSchema, usuarios, UsuarioWithNome } from 'service/api'
import { toast } from 'sonner'
import { EditarUsuarioFormFields } from '../forms/EditarUsuarioForm'

type OutletContext = {
    usuarios?: UsuarioWithNome[]
}

export default function EditarUsuario() {
    const navigate = useNavigate()
    const { usuarioId } = useParams()
    const { usuarios: lista } = useOutletContext<OutletContext>()
    const toggle = () => navigate('/administracao/usuarios')

    const { mutateAsync, isLoading } = usuarios.mutations.useUpdate({
        onSuccess: () => {
            toast.success('Usuário atualizado com sucesso!')
        },
        onError: (err: any) => {
            toast.error(err.message)
        },
        invalidateQuery: true,
    })

    const {
        decoded: { categoria },
    } = useAuth()

    const usuario = lista?.find(u => u.id === +usuarioId!)

    const myRank = rankingCategorias.indexOf(
        categoria as (typeof rankingCategorias)[number],
    )
    const targetRank = usuario
        ? rankingCategorias.indexOf(
              usuario.categoriaId as (typeof rankingCategorias)[number],
          )
        : -1
    const canEdit = targetRank > myRank

    if (!usuario || !canEdit) return null

    return (
        <Dialog.Root
            open
            onClose={toggle}
            width="xl"
            loading={isLoading}
            onSubmit={values =>
                mutateAsync({ id: usuario.id, ...values }).catch((e: any) => {
                    toast.error(e.message)
                    throw e
                })
            }
            schema={EditarUsuarioSchema}
            defaultValues={{
                email: usuario.email,
                nome: usuario.nomeInformado ?? '',
                categoriaId: usuario.categoriaId,
                clienteId: usuario.clienteId,
            }}
        >
            <Dialog.Title>Editar usuário</Dialog.Title>
            <Dialog.Content>
                <EditarUsuarioFormFields />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
